import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchCustomerSupport,
    deleteCustomerSupport,
} from "../../Redux/Reducers/UserFeedBacksupportReducer";
import {
    Box,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button as MuiButton,
    Tooltip,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import PageHeader1 from "../../components/common/PageHeader1";
import { usePermissions } from "../../context/AuthContext";

function MessageSupportDetails() {
    const { can } = usePermissions();
    const dispatch = useDispatch();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [filterModel, setFilterModel] = useState({
        items: [],
        quickFilterExcludeHiddenColumns: true,
        quickFilterValues: [''],
    });
    const { data: messages } = useSelector((state) => state.UserFeedBacksupport || {});
    const MessageData = useSelector((state) => state?.SupportQueryReducer?.queries || []);
    const pagination = useSelector((state) => state?.UserFeedBacksupport?.pagination);
    const [selectedMessageId, setSelectedMessageId] = useState(null);
    const [open, setOpen] = useState(false);

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});

    useEffect(() => {
        const { page, pageSize } = paginationModel;
        dispatch(fetchCustomerSupport({ page: page + 1, limit: pageSize }));
    }, [paginationModel, dispatch]);

    const handleClickOpen = (messageId) => {
        setSelectedMessageId(messageId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedMessageId(null);
    };

    const handleDelete = () => {
        if (selectedMessageId) {
            dispatch(deleteCustomerSupport(selectedMessageId));
            const { page, pageSize } = paginationModel;
            dispatch(fetchCustomerSupport({ page: page + 1, limit: pageSize }));
            handleClose();
        }
    };

    const columns = [
        { field: "sono", headerName: "S.No.", width: 80 },
        { field: "userName", headerName: "User Name", width: 200 },
        { field: "email", headerName: "Email", width: 250 },
        { field: "phoneNumber", headerName: "Phone Number", width: 150 },
        { field: "subject", headerName: "Subject", width: 150 },
        {
            field: "message",
            headerName: "FeedBack",
            width: 250,
            renderCell: ({ row }) => (
                <span>
                    {row?.message?.length > 25
                        ? row.message.substring(0, 25) + "..."
                        : row.message}
                </span>
            ),
        },
        { field: 'createdAt', headerName: 'Created At', width: 200 },
        {
            field: "actions",
            headerName: "Actions",
            width: 150,
            renderCell: ({ row }) => (
                <div>
                    <Tooltip title="View Feedback">
                        <IconButton
                            component={Link}
                            to={`/MessageView-detail/${row.id}`}
                        >
                            <i className="icofont-eye text-info"></i>
                        </IconButton>
                    </Tooltip>
                    {can('user_feedback:delete') && (
                        <Tooltip title="Delete Feedback">
                            <IconButton onClick={() => handleClickOpen(row.id)}>
                                <i className="icofont-ui-delete text-danger"></i>
                            </IconButton>
                        </Tooltip>
                    )}
                </div>
            ),
        },
    ];

    const rows = Array.isArray(MessageData?.data) ?
        MessageData?.data.map((message, index) => ({
            sono: paginationModel.page * paginationModel.pageSize + index + 1,
            id: message?._id,
            userName: message?.name,
            email: message?.email,
            phoneNumber: message?.mobile,
            subject: message?.subject,
            message: message?.description,
            createdAt: message?.createdAt
                ? new Date(message?.createdAt).toLocaleString()
                : "",
        }))
        : [];

    return (
        <div className="body d-flex py-1">
            <div className="container-xxl">
                <PageHeader1 pagetitle="User FeedBack List" />
                <div className="row g-0 mb-3">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <Box sx={{ width: "100%" }}>
                                    <Box sx={{ height: 500 }}>
                                        <DataGrid
                                            columns={columns}
                                            rows={rows}
                                            getRowId={(row) => row.id}
                                            disableRowSelectionOnClick
                                            slots={{ toolbar: GridToolbar }}
                                            filterModel={filterModel}
                                            onFilterModelChange={(newModel) => setFilterModel(newModel)}
                                            slotProps={{ toolbar: { showQuickFilter: true } }}
                                            columnVisibilityModel={columnVisibilityModel}
                                            onColumnVisibilityModelChange={(newModel) =>
                                                setColumnVisibilityModel(newModel)
                                            }
                                            paginationMode="server"
                                            rowCount={pagination?.totalDocs || 0}
                                            pageSizeOptions={[10, 25, 50, 100]}
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            autoHeight
                                        />
                                    </Box>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this message?
                </DialogContent>
                <DialogActions>
                    <MuiButton onClick={handleClose}>
                        Cancel
                    </MuiButton>
                    <MuiButton onClick={handleDelete} color="error">
                        Delete
                    </MuiButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default MessageSupportDetails;